module.exports = __webpack_public_path__ + "media/images/dogs/chocolate-toxic-calculator-how-to-get-the-cocoa-out-of-your-dog-s system.jpg";